<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_7">Contents</a></h1><a id="page_7">
</a><h2 class="toc-chap"><a id="page_7"></a><span href="#/xhtml/02_Introduction" title="Link target outside of Sample">Introduction</span></h2>
<h2 class="toc-chap"><a href="#/xhtml/03_Part01">Kwaidan</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/04_Chapter01">The Story of Mimi-Nashi-Hoichi</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/05_Chapter02" title="Link target outside of Sample">Oshidori</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/06_Chapter03" title="Link target outside of Sample">The Story of O-Tei</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/07_Chapter04" title="Link target outside of Sample">Ubazakura</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/08_Chapter05" title="Link target outside of Sample">Diplomacy</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/09_Chapter06" title="Link target outside of Sample">Of a Mirror and a Bell</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter07" title="Link target outside of Sample">Jikininki</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter08" title="Link target outside of Sample">Mujina</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter09" title="Link target outside of Sample">Rokuro-Kubi</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter10" title="Link target outside of Sample">A Dead Secret</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter11" title="Link target outside of Sample">Yuki-Onna</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter12" title="Link target outside of Sample">The Story of Aoyagi</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter13" title="Link target outside of Sample">Jiu-Roku-Zakura</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter14" title="Link target outside of Sample">The Dream of Akinosuke</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/18_Chapter15" title="Link target outside of Sample">Riki-Baka</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/19_Chapter16" title="Link target outside of Sample">Hi-Mawari</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/20_Chapter17" title="Link target outside of Sample">Horai</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/21_Chapter18" title="Link target outside of Sample">Insect Studies</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/21_Chapter18#lev1" title="Link target outside of Sample">Butterflies</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/22_Chapter19" title="Link target outside of Sample">Mosquitoes</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/23_Chapter20" title="Link target outside of Sample">Ants</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?5715f965